import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
    Box, Button, Card, CardContent, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput,
    Select, TextField, Typography, Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import { MyContext } from "../MyContext";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import CloseIcon from '@mui/icons-material/Close';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import axios from "axios";
import Helpers from '../Helpers';

const styles = {
    warningCard: {
        height: 460,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    warningIcon: {
        color: 'rgba(0,0,0, .7)',
        fontSize: 90,
    },
    warningText: {
        color: 'rgba(0,0,0, .7)',
        fontSize: 24,
    },
    card: {
        height: 'auto',
        backgroundColor: '#FFF',
        borderRadius: 1,
    },
    cardProduto: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: 0,
    },
    nmProduto: {
        fontWeight: 'bold',
        fontSize: 12,
        paddingX: 1,
    },
    cardRemove: {
        height: 26,
        backgroundColor: "#DA0C16",
        color: "#f5f5f5",
    },
    qtdeContainer: {
        width: '100%',
        height: 90,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: '#f5f9ff',
    },
    priceContainer: {
        width: '100%',
        height: 50,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    qtdeInput: {
        width: '32%',
        backgroundColor: '#fff',
    },
    priceValue: {
        fontWeight: 'bold',
        color: '#2c60a7',
    },
    boxValores: {
        width: '68%',
        height: 70,
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '2%',
        marginTop: '-5%',
    },
    boxValUnit: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1%',
        paddingX: 1,
    },
    labelValUnit: {
        width: '100%',
        fontStyle: 'italic',
        textTransform: 'uppercase',
        fontSize: 12,
    },
    priceValUnit: {
        width: '100%',
        fontWeight: 'bold',
        display: 'flex',
        flexDirection: 'row',
    },    
    cardBottom: {
        backgroundColor: '#FFF',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
    },
    boxBottom: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    footer: {
        width: '100%',
        height: 60,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    btnClear: {
        width: '50%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        backgroundColor: "#DA0C16",
    },
    btnSubmit: {
        width: '50%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        backgroundColor: "#2c60a7",
    },
    btnText: {
        color: '#F5F5F5',
        fontWeight: 'bold',
        fontSize: 13,
        textTransform: 'uppercase',
    },
    btnIcon: {
        color: '#F5F5F5',
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    btnAddProd: {
        width: '20%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        backgroundColor: "#2c60a7",
    },
};

function Checkout(){
    const navigate = useNavigate();
    const { auth, listaCarrinho, setListaCarrinho } = useContext(MyContext);
    const [urlApi, setUrlApi] = useState(process.env.REACT_APP_URL_API);
    const [tpEmpresa, setTpEmpresa] = useState(null);
    const [selectTiposPagto, setSelectTiposPagto] = useState([]);
    const [selectFormasPagto, setSelectFormasPagto] = useState([]);
    const [selectCartoesCredito, setSelectCartoesCredito] = useState([]);
    const [mostraSelectCartaoCred, setMostraSelectCartaoCred] = useState(false);
    const [vrMaxDesconto, setVrMaxDesconto] = useState(0);
    const [totalProdutos, setTotalProdutos] = useState(0);
    const [totalItens, setTotalItens] = useState(0);
    const [valorItens, setValorItens] = useState(0);
    const [valorItens2, setValorItens2] = useState(0);
    const [valorDesconto, setValorDesconto] = useState(0);
    const [idCliente, setIdCliente] = useState(0);
    const [nmCliente, setNmCliente] = useState('');
    const [checkoutProdutos, setCheckoutProdutos] = useState(listaCarrinho);
    const [checkout, setCheckout] = useState({
        idFormaPagto: 0,
        idCartaoCredito: 0,
        idTipoPagto: 0,
        idFuncionario: 0,
        vrDesconto: '',
        dtEntrega: '',
        hrEntrega: '',
    });

    useEffect(() => {
        const infoEmp = localStorage.getItem('infoEmpresa');

        if(infoEmp != null){
            setTpEmpresa(infoEmp);
        }

        setTimeout(() => {
            getAuth();
            getCliente();

            if(infoEmp !== 'Q'){
                getSelectsApi();
                getVrMaxDesconto();
            }            
            
            if(listaCarrinho.length > 0){
                setCheckoutProdutos(listaCarrinho);
                setIdCliente(listaCarrinho[0].idCliente);

                const totProdutos = listaCarrinho.length;
                const totItens = listaCarrinho.reduce((total, item) => total + Number(item.qtProduto), 0);
                const valItens = listaCarrinho.reduce((total, item) => total + (Number(item.qtProduto)*parseFloat(item.vrProduto)), 0);
                const valItens2 = listaCarrinho.reduce((total, item) => total + (Number(item.qtProduto)*parseFloat(item.vr_unitario)), 0);

                setTotalProdutos(totProdutos);
                setTotalItens(totItens);
                setValorItens(valItens);
                setValorItens2(valItens);
            }
        }, 1000);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if(listaCarrinho.length > 0){
                setCheckoutProdutos(listaCarrinho);
                setIdCliente(listaCarrinho[0].idCliente);

                console.log('listaCarrinho', listaCarrinho);

                const totProdutos = listaCarrinho.length;
                const totItens = listaCarrinho.reduce((total, item) => total + Number(item.qtProduto), 0);
                const valItens = listaCarrinho.reduce((total, item) => total + (Number(item.qtProduto)*parseFloat(item.vrProduto)), 0);
                const valItens2 = listaCarrinho.reduce((total, item) => total + (Number(item.qtProduto)*parseFloat(item.vr_unitario)), 0);

                setTotalProdutos(totProdutos);
                setTotalItens(totItens);
                setValorItens(Helpers.formataValorPtBr(valItens));
                setValorItens2(Helpers.formataValorPtBr(valItens2));
            }
        }, 3000);
    }, [listaCarrinho]);

    useEffect(() => {
        somaTotalItens();
        somaValorItens();
        setTotalProdutos(checkoutProdutos.length);
    }, [checkoutProdutos]);

    useEffect(() => {
        calculaValorDescontoReal();
        somaValorItens();
    }, [checkout.vrDesconto]);

    const getAuth = ()=>{
        const data = localStorage.getItem('userAuth');

        if(data != null){
            let user = JSON.parse(data);
            setCheckout(prev => ({...prev, idFuncionario: user.id_funcionario}));
        }
    };

    const getCliente = ()=>{
        const data = localStorage.getItem('clienteSelecionado');

        if(data != null){
            let cliente = JSON.parse(data);
            setNmCliente(cliente.nmFantasia);
        }
    };

    const getSelectsApi = async() => {
        Helpers.loadingAlert('Atualizando formas de pagamento');

        const rota = `${urlApi}/selects`;
        const resposta = await axios.get(rota);

        setSelectFormasPagto(resposta.data.formasPagto);
        setSelectTiposPagto(resposta.data.tiposPagto);
        setSelectCartoesCredito(resposta.data.cartoes_credito);

        return;
    };

    const getVrMaxDesconto = async() => {
        Helpers.loadingAlert('Atualizando formas de pagamento');

        const rota = `${urlApi}/${idCliente}/tab_tabelas`;
        const resposta = await axios.get(rota);

        setVrMaxDesconto(resposta.data);
        return;
    };

    const adicionarProdutoSqLite = (produto) => {
        const novoProduto = {
            idCliente: produto.idCliente,
            idProduto: produto.idProduto,
            nmProduto: produto.nmProduto,
            dsTravaEstoque: produto.dsTravaEstoque,
            vrProduto: produto.vrProduto,
            qtProduto: produto.qtProduto,
            dsObs: produto.dsObs,
            vr_unitario: produto.vr_unitario,
            valor_final: produto.valor_final,
            valor_base: produto.valor_base,
            vr_custo: produto.vr_custo,
            vr_custofp: produto.vr_custofp,
            valor_st: produto.valor_st,
            vr_mva: produto.vr_mva,
            vr_aliquotaicms: produto.vr_aliquotaicms,
            vr_aliquotaicmsst: produto.vr_aliquotaicmsst,
            vr_redubaseicms: produto.vr_redubaseicms,
            vr_alqpobreza: produto.vr_alqpobreza,
            alqpobreza: produto.alqpobreza,
            vbcfcpst: produto.vbcfcpst,
            ds_modalbcicmsst: produto.ds_modalbcicmsst,
            id_cfop: produto.id_cfop,
            id_almoxarifado: produto.id_almoxarifado,
            id_cst: produto.id_cst,
            id_cstipi: produto.id_cstipi,
            id_csosn: produto.id_csosn,
            id_estoqueprod: produto.id_estoqueprod,
            id_cstpis: produto.id_cstpis,
            id_cstcofins: produto.id_cstcofins,
            id_origemprodnfe: produto.id_origemprodnfe,
            id_nbm: produto.id_nbm,
            id_operacaofiscal: produto.id_operacaofiscal,
            id_enquadraipi: produto.id_enquadraipi,
            id_cest: produto.id_cest,
        };

        const prods = localStorage.getItem('carrinhoProdutos');
        let novosProdutos = [];

        if (prods) {
            const arrayProds = JSON.parse(prods);
            const filtrado = arrayProds.filter(p => p.idProduto !== produto.idProduto);
            novosProdutos = [...filtrado, novoProduto];
        } else {
            novosProdutos = [novoProduto];
        }

        // Atualiza o localStorage
        localStorage.setItem('carrinhoProdutos', JSON.stringify(novosProdutos));
    };

    const handleObsChange = (text, index) => {
        const novaLista = [...listaCarrinho];
        const ds_obs = Helpers.maxLenght(text, 150) || '';

        novaLista[index].dsObs = ds_obs;

        adicionarProdutoSqLite(novaLista[index]);
        setListaCarrinho(novaLista);
    };

    const handleInputChange = (text, index) => {
        const empresa = JSON.parse(localStorage.getItem('empresa') ?? '{}');
        const usarInputFloat = empresa.usarInputFloat;

        const novaLista = [...listaCarrinho];
        const qtDisponivel = novaLista[index].ctrEstoqProdutoWeb ? 999.999 : Math.max(0, Number(novaLista[index].qtProdutoDisponivel) || '');

        const result = Helpers.sanitizeQuantidade(text, usarInputFloat, novaLista[index].ctrEstoqProdutoWeb, qtDisponivel);
        novaLista[index].qtProduto = result.raw;

        adicionarProdutoSqLite(novaLista[index]);
        setListaCarrinho(novaLista);
        setCheckoutProdutos(novaLista);
    };

    const somaTotalItens = () => {
        let qtde = 0;

        checkoutProdutos.forEach(element => {            
            qtde = (Number(qtde)+Number(element.qtProduto));
        });

        setTotalItens(qtde);
    };

    const somaValorItens = () => {
        let vlr = 0;
        let subTotal = 0;
        let pcDesconto = (checkout.vrDesconto !== '') ? parseFloat(checkout.vrDesconto) : 0;

        checkoutProdutos.forEach(element => {
            vlr = (Number(vlr)+(Number(element.qtProduto)*Number(element.vrProduto)));            
        });

        const vlrDesconto = (vlr * (1 - pcDesconto / 100));
        subTotal = (vlr - vlrDesconto);

        setValorDesconto(subTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
        setValorItens(vlrDesconto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    };

    const removeItem = (id_produto) => {
        setListaCarrinho(prevList => {
            const novaLista = prevList.filter(item => Number(item.idProduto) !== Number(id_produto));
            // Se `checkoutProdutos` for sincronizado com `listaCarrinho`, atualize aqui também
            setCheckoutProdutos(novaLista);

            localStorage.removeItem('carrinhoProdutos');

            if(novaLista.length > 0){
                localStorage.setItem('carrinhoProdutos', JSON.stringify(novaLista));
            }

            somaTotalItens();
            somaValorItens();

            return novaLista;
        });
    };

    const limparCarrinho = () => {
        localStorage.removeItem('carrinhoProdutos');
        localStorage.removeItem('clienteSelecionado');

        setListaCarrinho([]);

        Helpers.toastAlert({
            title: "Seu carrinho de pedidos está limpo.",
            icon: "success",
        });

        return navigate('/clientes');
    };

    const handleShowSelectCartaoCred = (id_tipopagto, select_tipospagto) => {
        setCheckout((prev) => ({ ...prev, idTipoPagto: id_tipopagto }));

        const registro = select_tipospagto.filter(item => Number(item.id) === Number(id_tipopagto));
        let dsRegistro = registro[0].ds_registro;

        if(dsRegistro.toLowerCase().includes('cartao')){
            setMostraSelectCartaoCred(true);
        }else{
            setMostraSelectCartaoCred(false);
            setCheckout((prev) => ({ ...prev, idCartaoCredito: 0 }));
        }
    };

    const calculaValorDescontoReal = () => {
        if(checkout.vrDesconto > vrMaxDesconto){
            setCheckout(prevState => ({ ...prevState, vrDesconto: '' }));

            return Helpers.showAlert({
                title: 'Atenção !!!',
                text: `Máximo desconto: ${vrMaxDesconto}%`,
                icon: 'warning'
            });
        }
    };

    const carrinhoCliente = () => {
        if(listaCarrinho.length > 0){  
            const id = Number(listaCarrinho[0].idCliente);
            navigate('/produtos', { state: { idCliente: id } });
        }
    };

    const handleSubmit = async() => {
        if(checkoutProdutos.length == 0){
            return Helpers.showAlert({
                title: 'Atenção !!!',
                text: 'Adicione no mínimo 1 produto ao pedido.',
                icon: 'warning'
            });
        }

        if(checkout.idTipoPagto == 0 && tpEmpresa !== 'Q'){
            return Helpers.showAlert({
                title: 'Atenção !!!',
                text: 'Informe o tipo de pagamento.',
                icon: 'warning'
            });
        }

        if(checkout.idFormaPagto == 0 && tpEmpresa !== 'Q'){
            return Helpers.showAlert({
                title: 'Atenção !!!',
                text: 'Informe a forma de pagamento.',
                icon: 'warning'
            });
        }

        for (const element of listaCarrinho) {
            if (element.qtProduto == 0 || element.qtProduto === '') {
                const dsProdutos = Array.isArray(element.nmProduto)
                    ? element.nmProduto.join(', ')
                    : element.nmProduto;

                Helpers.showAlert({
                    title: 'Atenção !!!',
                    text: `Informe a quantidade dos produtos: ${dsProdutos}`,
                    icon: 'warning'
                });

                setTimeout(() => {
                    window.location.reload();
                }, 1500);

                return true;
            }
        }

        if(tpEmpresa !== 'Q'){
            const registro = selectTiposPagto.filter(item => Number(item.id) === Number(checkout.idTipoPagto));
            let dsRegistro = registro[0].ds_registro;
    
            if(checkout.idTipoPagto > 0 && dsRegistro.toLowerCase().includes('cartao') && checkout.idCartaoCredito == 0){
                return Helpers.showAlert({
                    title: 'Atenção !!!',
                    text: 'Informe qual a bandeira do cartão que será usado.',
                    icon: 'warning'
                });
            }
        }

        const btnSubmit = document.getElementById('btnSubmit');
        btnSubmit.disabled = true; // Desabilita o botão
        
        const rota = `${urlApi}/pedidos-vendas`;
        const dados = {
            checkout: checkout,
            produtos: checkoutProdutos,
        };

        await axios.post(rota, dados, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(async(response) => {            
            Helpers.toastAlert({
                title: response.data.message,
                icon: response.data.type,
            });

            if(response.data.type === 'success'){
                localStorage.removeItem('carrinhoProdutos');

                setListaCarrinho([]);
                setCheckoutProdutos([]);
                setCheckout({
                    idFormaPagto: 0,
                    idCartaoCredito: 0,
                    idTipoPagto: 0,
                    idFuncionario: auth?.idFuncionario,
                    vrDesconto: '',
                    dtEntrega: '',
                    hrEntrega: '',
                });

                return navigate('/clientes');
            }
        }).catch((err) => {
            console.log('erro context', err);

            const btnSubmit = document.getElementById('btnSubmit');
            btnSubmit.disabled = false; // habilita o botão
        });
    };

    return (
        <Grid container rowSpacing={2} columnSpacing={2} >
            {
                (listaCarrinho.length <= 0)
                ? (
                    <Grid container size={12} sx={styles.warningCard}>
                        <AddShoppingCartIcon sx={styles.warningIcon}/>
                        <Typography sx={styles.warningText}>
                            O carrinho de pedidos está vazio
                        </Typography>
                    </Grid>
                )
                : (
                    <Grid container size={12}>
                        <Grid size={{ xs: 12, md: 12 }} sx={{ marginBottom: 1, borderBottom: '3px solid #DA0C16', display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Typography sx={{ fontWeight: 'bold' }}>{nmCliente}</Typography>

                            <Button size={'small'} onClick={()=>carrinhoCliente()} sx={styles.btnAddProd}>
                                <AddShoppingCartIcon sx={styles.btnIcon} />
                            </Button>
                        </Grid>

                        {
                            listaCarrinho.map((item, index)=>{
                                const total = Helpers.formataValorPtBr(item.qtProduto * item.vrProduto);
                                const totalUnit = Helpers.formataValorPtBr(item.qtProduto * item.vr_unitario);
                                const vrProduto = Helpers.formataValorPtBr(item.vrProduto);
                                const vrUnitario = Helpers.formataValorPtBr(item.vr_unitario);

                                return (
                                    <Grid key={index} size={{ xs: 12, md: 4 }} >
                                        <Card sx={styles.card}>
                                            <CardContent sx={styles.cardProduto}>
                                                <Typography sx={styles.nmProduto}>{item.nmProduto}</Typography>
                                                <Button size={'small'} onClick={()=>removeItem(item.idProduto)} sx={styles.cardRemove}>
                                                    <CloseIcon />
                                                </Button>
                                            </CardContent>

                                            <CardContent sx={styles.qtdeContainer}>
                                                <FormControl variant="outlined" sx={styles.qtdeInput}>
                                                    <InputLabel htmlFor="outlined-adornment-password">Quantidade</InputLabel>
                                                    <OutlinedInput
                                                        id="outlined-adornment-password"
                                                        type={'text'}
                                                        value={item.qtProduto}
                                                        onChange={(e) => handleInputChange(e.target.value, index)}
                                                        sx={{ height: 36}}
                                                        /*startAdornment={
                                                            <InputAdornment position="start">
                                                                <IconButton
                                                                    onClick={()=>handleDecrement(index)}
                                                                    edge="end"
                                                                >
                                                                    <RemoveCircleIcon />
                                                                </IconButton>                                                                
                                                            </InputAdornment>
                                                        }*/
                                                        /*endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    onClick={()=>handleIncrement(index)}
                                                                    edge="start"
                                                                >
                                                                    <AddCircleIcon />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }*/
                                                        label="Quantidade"
                                                    />
                                                </FormControl>

                                                {
                                                    (tpEmpresa === 'Q')
                                                    ? (
                                                        <Box sx={styles.boxValores}>
                                                            <Box sx={styles.boxValUnit}>
                                                                <Typography sx={styles.labelValUnit}>vr.unitário</Typography>
                                                                <Typography sx={styles.priceValUnit}>x {vrUnitario} = {totalUnit}</Typography>
                                                            </Box>
                                                            <Box sx={styles.boxValUnit}>
                                                                <Typography sx={styles.labelValUnit}>vr. c/ imposto</Typography>
                                                                <Typography sx={styles.priceValUnit}>x {vrProduto} = {total}</Typography>
                                                            </Box>
                                                        </Box>
                                                    )
                                                    : (
                                                        <CardContent sx={styles.priceContainer}>
                                                            <Typography sx={styles.priceValUnit}>x {vrProduto}</Typography>
                                                            <Typography sx={styles.priceValue}>= {total}</Typography>
                                                        </CardContent>
                                                    )
                                                }

                                            </CardContent>

                                            <CardContent sx={{ padding: 0, marginBottom: -3 }}>
                                                <Accordion>
                                                    <AccordionSummary
                                                        expandIcon={<ArrowDropDownIcon />}
                                                        aria-controls="panel2-content"
                                                        id="panel2-header"
                                                    >
                                                        <Typography component="span" sx={{ textTransform: 'uppercase', fontSize: 14, fontWeight: 'bold' }}>
                                                            Observação <small>({item.dsObs.length}/150)</small>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails>
                                                        <TextField
                                                            id="outlined-multiline-static"
                                                            defaultValue={item.dsObs}
                                                            onChange={(e) => handleObsChange(e.target.value, index)}
                                                            multiline
                                                            fullWidth 
                                                            rows={4}
                                                            slotProps={{ htmlInput: { maxLength: 150 } }}
                                                        />
                                                    </AccordionDetails>
                                                </Accordion>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                )
            }

            {
                (tpEmpresa !== 'Q') && 
                <>
                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormControl fullWidth sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                            <InputLabel id="idTipoPagto">Tipo de pagamento</InputLabel>
                            <Select
                                labelId="idTipoPagto"
                                id="idTipoPagto"
                                label="Tipo de pagamento"
                                size="small"
                                defaultValue={checkout.idTipoPagto}
                                onChange={(e) => handleShowSelectCartaoCred(e.target.value, selectTiposPagto)}
                                sx={{ backgroundColor: '#fff' }}
                            >
                                <MenuItem value={0} disabled>Selecione uma opção</MenuItem>
                                {
                                    (selectTiposPagto.length > 0) &&
                                    selectTiposPagto.map((item, index)=>{
                                        return <MenuItem value={item.id}>{item.ds_registro}</MenuItem>;
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    { 
                        (mostraSelectCartaoCred) && 
                        <Grid size={{ xs: 12, md: 3 }}>
                            <FormControl fullWidth sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                                <InputLabel id="idCartaoCredito">Cartão</InputLabel>
                                <Select
                                    labelId="idCartaoCred"
                                    id="idCartaoCred"
                                    label="Cartão"
                                    size="small"
                                    defaultValue={checkout.idCartaoCredito}
                                    onChange={(e) => setCheckout((prev) => ({ ...prev, idCartaoCredito: e.target.value }))}
                                    sx={{ backgroundColor: '#fff' }}
                                >
                                    <MenuItem value={0} disabled>Selecione uma opção</MenuItem>
                                    {
                                        (selectCartoesCredito.length > 0) &&
                                        selectCartoesCredito.map((item, index)=>{
                                            return <MenuItem value={item.id}>{item.ds_registro}</MenuItem>;
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    }

                    <Grid size={{ xs: 12, md: 3 }}>
                        <FormControl fullWidth sx={{ borderRadius: 5, backgroundColor: '#f5f5f5' }}>
                            <InputLabel id="idFormaPagto">Forma de pagamento</InputLabel>
                            <Select
                                labelId="idFormaPagto"
                                id="idFormaPagto"
                                label="Forma de pagamento"
                                size="small"
                                defaultValue={checkout.idFormaPagto}
                                onChange={(e) => setCheckout((prev) => ({ ...prev, idFormaPagto: e.target.value }))}
                                sx={{ backgroundColor: '#fff' }}
                            >
                                <MenuItem value={0} disabled>Selecione uma opção</MenuItem>
                                {
                                    (selectFormasPagto.length > 0) &&
                                    selectFormasPagto.map((item, index)=>{
                                        return <MenuItem value={item.id}>{item.ds_registro}</MenuItem>;
                                    })
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 6, md: 2 }}>
                        <TextField
                            id="vrDesconto" 
                            type="text"
                            label="Desconto (%)" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={checkout.vrDesconto}
                            onChange={(e) =>
                                setCheckout((prev) => ({ ...prev, vrDesconto: Helpers.mascaraPorcentagem(e.target.value) }))
                            }
                            sx={{ backgroundColor: '#fff' }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid size={{ xs: 6, md: 2 }}>
                        <TextField
                            id="dtEntrega" 
                            type="date"
                            label="Data entrega" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={checkout.dtEntrega}
                            onChange={(e) =>
                                setCheckout((prev) => ({ ...prev, dtEntrega: e.target.value }))
                            }
                            sx={{ backgroundColor: '#fff' }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>

                    <Grid size={{ xs: 6, md: 2 }}>
                        <TextField
                            id="hrEntrega" 
                            type="time"
                            label="Hora entrega" 
                            variant="outlined"
                            size="small"
                            fullWidth 
                            value={checkout.hrEntrega}
                            onChange={(e) =>
                                setCheckout((prev) => ({ ...prev, hrEntrega: e.target.value }))
                            }
                            sx={{ backgroundColor: '#fff' }}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                </>
            }

            <Grid size={12} sx={styles.cardBottom}>
                <Box sx={styles.boxBottom}>
                    <Typography sx={{ fontWeight: 'bold' }}>{totalProdutos}</Typography>
                    <Typography>Produtos</Typography>
                </Box>
                <Box sx={styles.boxBottom}>
                    <Typography sx={{ fontWeight: 'bold' }}>{totalItens}</Typography>
                    <Typography>Itens</Typography>
                </Box>
                {
                    (tpEmpresa !== 'Q') ? <>
                        <Box sx={styles.boxBottom}>
                            <Typography sx={{ fontWeight: 'bold' }}>R$ {valorDesconto}</Typography>
                            <Typography>Desconto</Typography>
                        </Box>
                    </> : <>
                        <Box sx={styles.boxBottom}>
                            <Typography sx={{ fontWeight: 'bold' }}>R$ {valorItens2}</Typography>
                            <Typography>Total s/ imposto</Typography>
                        </Box>
                    </>
                }
                
                <Box sx={styles.boxBottom}>
                    <Typography sx={{ fontWeight: 'bold' }}>R$ {valorItens}</Typography>
                    <Typography>Total c/ imposto</Typography>
                </Box>
            </Grid>

            {
                (listaCarrinho.length > 0) && (
                    <Grid size={12} sx={styles.footer}>
                        <Button size={'small'} onClick={limparCarrinho} sx={styles.btnClear}>
                            <ShoppingCartIcon sx={styles.btnIcon} />
                            <Typography sx={styles.btnText}>Apagar carrinho</Typography>
                        </Button>
                        <Button id={'btnSubmit'} size={'small'} onClick={handleSubmit} sx={styles.btnSubmit} >
                            <LocalAtmIcon sx={styles.btnIcon} />
                            <Typography sx={styles.btnText}>Finalizar pedido</Typography>
                        </Button>
                    </Grid>
                )
            }
        </Grid>
    );
}

export default Checkout;